/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-type is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";

// NewUser page components
import FormField from "modules/inspections/components/FormField";
import { useState } from "react";
import { Card, Divider, Switch } from "@mui/material";
import { SyncLoader } from 'react-spinners';
import SoftSelect from "components/SoftComponents/SoftSelect";
import SoftInput from "components/SoftComponents/SoftInput";
import MultipleImageUpload from "./MultipleImageUpload";
import SoftButton from "components/SoftComponents/SoftButton";
import { ErrorMessage } from "formik";

function DeviceNotes({ formData }) {
    const {
        values, touched, errors, formField, isSubmitting,
        functions: { setDeviceOptions, setFieldValue, handleChange, handleBack, handleCancel },
        custom: { activeStep, isLastStep, user, all_devices, deviceOptions }
    } = formData;
    const { devicePrimary, deviceSecondary, title, description, inspection_type } = formField;

    return (
        <SoftBox>
            <SoftBox mb={3} display="flex" flexDirection="column" alignItems="center">
                <SoftTypography variant="h4" fontWeight="bold" textAlign="center">
                    Notes & Image Upload
                </SoftTypography>
                <SoftTypography pt={1} variant="mobileBody1" textAlign="center">
                    Note down any additional information, and upload images of the site.
                </SoftTypography>
            </SoftBox>
            <SoftBox mt={3}>
                <Grid container spacing={1}>
                    <Grid item xxs={12}>
                        <FormField
                            type={title.type}
                            label={title.label}
                            name={title.name}
                            value={values.title}
                            placeholder={`'${values['inspection_type']}'`}
                            error={errors.title && touched.title}
                            success={values.title.length > 0 && !errors.title}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xxs={12} lg={12}>
                        <FormField
                            type={description.type}
                            label={description.label}
                            name={description.name}
                            value={values.description}
                            placeholder={description.placeholder}
                            error={errors?.description && touched?.description}
                            success={values?.description.length > 0 && !errors?.description}
                            onChange={handleChange}

                            multiline
                            rows={4}
                        />
                    </Grid>
                    <Grid item xxs={12} lg={12}>
                        <SoftBox mb={0.75}>
                            <SoftTypography component="div" variant="caption" color="error">
                                <ErrorMessage name={values['deviceSecondary-uuid']?.trim().length > 0 ? deviceSecondary.images.name : devicePrimary.images.name} />
                            </SoftTypography>
                        </SoftBox>
                        <SoftBox>
                            <MultipleImageUpload
                                field={values['deviceSecondary-uuid']?.trim().length > 0 ? deviceSecondary.images : devicePrimary.images}
                                values={values['deviceSecondary-uuid']?.trim().length > 0 ? values['deviceSecondary-images'] : values['devicePrimary-images']}
                                setFieldValue={setFieldValue}
                            />
                        </SoftBox>
                    </Grid>
                </Grid>
            </SoftBox>
            <SoftBox mt={4} width="100%" display="flex" justifyContent="space-between">
                <SoftButton variant="gradient" color={activeStep === 0 ? "error" : "light"} onClick={activeStep === 0 ? handleCancel : handleBack}>
                    {activeStep === 0 ? "cancel" : "back"}
                </SoftButton>
                <SoftButton
                    disabled={isSubmitting}
                    type="submit"
                    variant="gradient"
                    color="dark"
                >
                    {isLastStep ? "submit" : "next"}
                </SoftButton>
            </SoftBox>
        </SoftBox>
    );
}

// typechecking props for DeviceNotes
DeviceNotes.propTypes = {
    formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};

export default DeviceNotes;
